export var MAIN_FORM_STEPS;
(function (MAIN_FORM_STEPS) {
    MAIN_FORM_STEPS["APPLICANT_PAGE"] = "page1";
    MAIN_FORM_STEPS["PROJECT_PAGE"] = "page2";
    MAIN_FORM_STEPS["APPLICANT_OCCUPATION_PAGE"] = "page3";
    MAIN_FORM_STEPS["ADDITIONAL_CHARGE_CALCULATOR_PAGE"] = "page3a";
    MAIN_FORM_STEPS["ADVICE_PAGE"] = "page4";
    MAIN_FORM_STEPS["SUCCESS_SCREEN"] = "page4b";
    MAIN_FORM_STEPS["REFUSED_BY_PRESCORING_SCREEN"] = "page4c";
})(MAIN_FORM_STEPS || (MAIN_FORM_STEPS = {}));
